<template>
  <div class="my-promotion">
    <div class="header">
      <div class="top-title">
        <span class="iconfont iconhoutui" @click="goBack"></span>
        <div>分销商</div>
      </div>
      <div class="num">{{ Info.commissionCount }}</div>
      <div class="profit acea-row row-between-wrapper">
        <div class="item">
          <div>推广人数</div>
          <div class="money">{{ Info.spread_num }}</div>
        </div>
        <div class="item">
          <div>昨日收益</div>
          <div class="money">{{ Info.yesterday_commission }}</div>
        </div>
        <div class="item">
          <div>累计已提</div>
          <div class="money">{{ Info.total_withdraw }}</div>
        </div>
      </div>
    </div>
    <div class="bnt bg-color-red" @click="toCash">立即提现</div>
    <div class="list acea-row row-between-wrapper">
      <router-link class="item row-column" :to="'/invitation'">
        <span class="iconfont iconicon_erweima"></span>
        <div>推广名片</div>
      </router-link>
      <router-link class="item row-column" :to="'/oil_promoter'">
        <span class="iconfont icontongji"></span>
        <div>推广人统计</div>
      </router-link>
      <router-link class="item row-column" :to="'/mylrecord_list'">
        <span class="iconfont iconicon-qiandai"></span>
        <div>提现记录</div>
      </router-link>
      <router-link class="item row-column" to="/commissionLogs">
        <span class="iconfont iconicon-dingdan"></span>
        <div>佣金记录</div>
      </router-link>
      <router-link class="item row-column" to="/spread_order?order_type=1">
        <span class="iconfont iconicon-dingdan"></span>
        <div>分销订单</div>
      </router-link>
      <router-link class="item row-column" to="/spread_order?order_type=2">
        <span class="iconfont iconicon-dingdan"></span>
        <div>推广充值</div>
      </router-link>
    </div>
  </div>
</template>
<script>
import User from "@api/user";
export default {
  name: "UserPromotion",
  props: {},
  data: function() {
    return {
      Info: {
        lastDayCount: 0,
        extractCount: 0,
        commissionCount: 0
      }
    };
  },
  mounted: function() {
    this.invitecode();
  },
  methods: {
    toCash() {
      this.$router.push({
        path: "/mycash?money=" + this.Info.commission,
      });
    },
    goPer() {
      this.$router.push('/vip_mycenter')
    },
    async invitecode() {
      try {
        const res = await User.getCommission();
        this.Info = res.data;
        this.$set(this.Info, "commissionCount", res.data.current_money);
        this.$set(this.Info, "extractCount", res.data.withdraw_money);
        this.$set(this.Info, "lastDayCount", res.data.yes_money);
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../index.scss";
/*我的推广*/
.my-promotion {
  height: 100vh;
}
.top-title {
  width: 100%;
  height: 50px;
  line-height: 50px;
  display: flex;
  font-size: 16px;
  color: #fff;
  padding: 0 20px;
}
.top-title div {
  margin-left: 130px;
}
.my-promotion .header {
  background-image: url("../../../../../../public/static/images/vip/promotionBg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 100%;
  height: 188px;
}

.my-promotion .header .name {
  font-size: 15px;
  color: #fff;
  padding-top: 29px;
  position: relative;
  text-align: center;
}

.my-promotion .header .name .record {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.8);
  position: absolute;
  top: 138px;
  width: 140px;
}
.myCenter {
  width: 100%;
  position: relative;
  right: 10px;
  display: flex;
  align-items: center;

  .iconhoutui {
    position: absolute;
    left: 0;
    font-size: 18px!important;
  }
}
.my-promotion .header .name .record .iconfont {
  font-size: 12px;
  margin-left: 5px;
}

.my-promotion .header .num {
  text-align: center;
  color: #fff;
  margin-top: 12px;
  font-size: 45px;
  font-family: "GuildfordProBook 5";
}

.my-promotion .header .profit {
  padding: 0 10px;
  margin-top: 17px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: space-between;
}

.my-promotion .header .profit .item {
  min-width: 100px;
  text-align: center;
}

.my-promotion .header .profit .item .money {
  font-size: 17px;
  color: #fff;
}

.my-promotion .bnt {
  font-size: 14px;
  color: #fff;
  width: 129px;
  height: 34px;
  border-radius: 25px;
  text-align: center;
  line-height: 34px;
  margin: -16px auto 0 auto;
  background: linear-gradient(to bottom, #f10c0c 0%, #ec9b08 100%) !important;
}

.my-promotion .list {
  padding: 0 10px;
  margin-top: 5px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.my-promotion .list .item {
  width: 172px;
  height: 120px;
  border-radius: 10px;
  background-color: #fff;
  margin-top: 10px;
  font-size: 15px;
  color: #666;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.my-promotion .list .item .iconfont {
  font-size: 35px;
  background-image: linear-gradient(to bottom, #f10c0c 0%, #ec9b08 100%);
  background-image: -webkit-linear-gradient(to right, #fc4d3d 0%, #e93323 100%);
  background-image: -moz-linear-gradient(to right, #fc4d3d 0%, #e93323 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 10px;
}
</style>
